import { render, staticRenderFns } from "./throughRec_zh.vue?vue&type=template&id=123348d3&scoped=true"
import script from "./throughRec_zh.vue?vue&type=script&lang=js"
export * from "./throughRec_zh.vue?vue&type=script&lang=js"
import style0 from "./throughRec_zh.vue?vue&type=style&index=0&id=123348d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123348d3",
  null
  
)

export default component.exports